module.exports = __webpack_public_path__ + "img/AnyReadNew.6f79a08d.png";